import { ITerm } from '../../../../interfaces/services/ISPTermStorePickerService';
import SPTermStorePickerService from '../../../../services/SPTermStorePickerService';

export interface ITermActionsControlProps {
  term: ITerm;
  termActions: ITermActions;
  spTermService: SPTermStorePickerService;
  termActionCallback: (updateAction: UpdateAction | null) => void;
}

export interface ITermActionsControlState {
  availableActions: ITermAction[];
  displayMode: TermActionsDisplayMode;
  displayStyle: TermActionsDisplayStyle;
  termActionChanges?: TermActionChange;
}

export interface TermActionChange {
  [termId: string]: ActionChange[];
}

export interface ActionChange {
  actionId: string;
  disabled?: boolean;
  hidden?: boolean;
}

export interface IConcreteTermActionProps {
  termActions: ITermAction[];
  term: ITerm;
  displayStyle: TermActionsDisplayStyle;
  spTermService: SPTermStorePickerService;
  termActionChanges: TermActionChange;
  termActionCallback: (updateAction: UpdateAction | null) => void;
}

export enum TermActionsDisplayMode {
  buttons = 1,
  dropdown
}

export enum TermActionsDisplayStyle {
  text = 1,
  icon,
  textAndIcon
}

export enum UpdateType {
  updateTermLabel = 1,
  updateTermsTree,
  hideTerm,
  disableTerm,
  selectTerm
}

export interface UpdateAction {
  updateActionType: UpdateType;
  value?: string | boolean;
}

export interface ITermActions {
  actions: ITermAction[];
  termActionsDisplayStyle?: TermActionsDisplayStyle;
  termActionsDisplayMode?: TermActionsDisplayMode;
  initialize?: (spTermService: SPTermStorePickerService) => Promise<void>;
}

export interface ITermAction {
  id: string;
  title: string;
  iconName?: string;
  hidden?: boolean;
  invokeActionOnRender?: boolean;

  applyToTerm: (currentTerm: ITerm, triggerActionCallback: (updateAction: UpdateAction) => void, setActionStateForTerm: (actionId: string, termId: string, type: "disabled" | "hidden", value: boolean) => void) => Promise<boolean> | boolean;
  actionCallback: (spTermService: SPTermStorePickerService, currentTerm: ITerm) => Promise<UpdateAction>;
}
